// ** Reducers Imports
import navbar from './navbar'
import layout from './layout'
import commerce from './commerce'
import auth from './authentication'
import todo from '@src/views/apps/todo/store'
import chat from '@src/views/apps/chat/store'
import users from '@src/views/apps/user/store'
import email from '@src/views/apps/email/store'
import kanban from '@src/views/apps/kanban/store'
import invoice from '@src/views/apps/invoice/store'
import calendar from '@src/views/apps/calendar/store'
import ecommerce from '@src/views/apps/ecommerce/store'
import dataTables from '@src/views/tables/data-tables/store'
import permissions from '@src/views/apps/roles-permissions/store'
import { withdraw } from '@src/views/common/bancamiga-wallet/withdrawal/store'
import { kidsList } from '@src/views/customers/store'
import { workTeam } from '../views/common/work-team/store'
import { usersList } from '@src/views/toll-system/vehicles/store'
import { superadminArea } from '@src/views/parking/areas-admin/store'
import { superadminZone } from '@src/views/parking/zones-admin/store'
import { superadminSubzone } from '@src/views/parking/subzone-admin/store'

const rootReducer = {
  auth,
  commerce,
  todo,
  chat,
  email,
  users,
  kanban,
  navbar,
  layout,
  invoice,
  calendar,
  ecommerce,
  dataTables,
  permissions,
  withdraw,
  workTeam,
  usersList,
  superadminArea,
  superadminZone,
  superadminSubzone,
  kidsList
}

export default rootReducer
